import React, { useState } from 'react';
import { getMaxStake } from '../../../store/actions/betSlip';
import styles from './BetStakeInput.module.scss';
import NumericKeyboard from '../../shared/VirtualKeyboard/NumericKeyboard';
import { roundNumber } from '../../../utils/formatDecimal';
import { getTranslation } from '../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import { BETSTAKE_CONSTANTS } from '../../../constants/defaultValues';
import { isESportBetLine, isOnlyESport } from '../../../utils/helpers';

export default function BetStakeInput({ stake, setStakeValue, inputWidth, isLive, betLine }) {
    const dispatch = useDispatch();

    const [showKeyboard, setShowKeyboard] = useState(false);

    const betLines = useSelector(state => state.betSlip.betLines);
    const stakeLimits = useSelector(state => state.betSlip.stakeLimits);

    const isESportIncluded = betLine ? isESportBetLine(betLine) : isOnlyESport(betLines);
    const minStake = isESportIncluded ? stakeLimits.eSportMinimum : stakeLimits.sportMinimum;

    const incStake = () => {
        let newStake;

        if (stake === null || stake === undefined || !Number.isInteger(Number(stake))) {
            newStake = minStake;
        } else {
            newStake = parseInt(stake) + 1;
        }

        setStakeValue(newStake);
    };

    const decStake = () => {
        let newStake;

        if (stake === null || stake === undefined || !Number.isInteger(Number(stake))) {
            newStake = minStake;
        } else {
            newStake = parseInt(stake) - 1;
        }

        if (newStake < minStake) return;

        setStakeValue(newStake);
    };

    const onChangeKeyboardValue = value => {
        setStakeValue(parseInt(value));
        setShowKeyboard(false);
    };

    const onChangeInputValue = value => {
        if(value<0) return;

        const formattedValue = value > 0 ? roundNumber(value, 0) : value;
        setStakeValue(formattedValue);
    };

    const onBetMaxClick = async () => {
        const maxStake = await dispatch(getMaxStake(betLine));

        setStakeValue(maxStake);
    };

    return (
        <div className={styles.stakeContainer}>
            {showKeyboard && (
                <NumericKeyboard
                    setInputValue={value => onChangeKeyboardValue(value)}
                    style={{ position: 'fixed', right: '375px', top: '410px' }}
                    close={() => setShowKeyboard(false)}
                />
            )}
            <div className={'flex'}>
                <button className={styles.betMaxButton} onClick={onBetMaxClick}>
                    {getTranslation('betSlip.betLine.betMax')}
                </button>

                <div className={styles.stakeInputGroup}>
                    <div className={styles.stakeInput} style={{ width: inputWidth }}>
                        <button
                            onClick={decStake}
                            className={`${styles.changeStakeButton} ${styles.decStakeBtn}`}
                        >
                            -
                        </button>
                        <input
                            className={styles.input}
                            type='number'
                            min={minStake}
                            value={stake}
                            onChange={event => onChangeInputValue(event.target.value)}
                            onFocus={e => e.target.select()}
                        />
                        <button
                            onClick={incStake}
                            className={`${styles.changeStakeButton} ${styles.incStakeBtn}`}
                        >
                            +
                        </button>
                    </div>
                    <button
                        className='icon-keyboard'
                        onClick={() => setShowKeyboard(!showKeyboard)}
                    />
                </div>
            </div>
            <div className={'flex'}>
                {BETSTAKE_CONSTANTS.filter(stake => minStake <= stake)
                    .slice(0, 6)
                    .map(betStake => (
                        <button
                            key={betStake}
                            className={styles.betStakeButton}
                            onClick={() => setStakeValue(betStake)}
                        >
                            {betStake}
                        </button>
                    ))}
            </div>
        </div>
    );
}
